/** The world's invitation, all in one place: a small QR code of its link, its code, Share and Copy link. */
import type { JSX } from 'react';

import { inviteTo } from '@game/session/invite';
import type { WorldInfo } from '@game/types';
import { t } from '@i18n/index';
import { QrCode } from '@ui/components/QrCode';
import { ShareButtons } from '@ui/components/ShareButtons';

export function Invite({ world }: { world: WorldInfo }): JSX.Element {
  const { link, code } = inviteTo(world.id);
  return (
    <section className="invite" aria-labelledby="invite-title">
      <h3 id="invite-title">{t('world.invite')}</h3>
      <div className="invite-row">
        <QrCode text={link} label={t('world.qr-aria')} />
        <div className="invite-words">
          <p className="world-code" aria-label={`${t('world.code')} ${code}`}>
            {code}
          </p>
          <p className="note">{t('world.invite-hint')}</p>
          <ShareButtons world={world} />
        </div>
      </div>
    </section>
  );
}
